const DROPDOWN_SECTION_TYPE = Object.freeze({
  SINGLE_SELECT: "single-select",
  MULTI_SELECT: "multi-select"
});
export {
  DROPDOWN_SECTION_TYPE
};
//# sourceMappingURL=constants.mjs.map
